// @flow
import React from 'react';
import Text from './Typography';

type RadioProps = {
  id: number,
  label: string,
  checked: boolean,
  onToggle: (evt: Event) => void,
  onMouseUp: (evt: Event) => void,
  onMouseDown: (evt: Event) => void,
  index: number,
  isActive: boolean,
  isHorizontal: boolean,
  type: string,
  error?: string
}

const Radio = ({ id, label, checked, isActive, onMouseUp,
  onMouseDown, isHorizontal, type, error } : RadioProps) => (
    <div
      className={
        `radio-item
        ${isActive ? 'is-active' : ''}
        ${isHorizontal ? 'radio-item--horizontal' : ''}
        ${type === id && isHorizontal ? 'radio-item--horizontal-checked' : ''}
        ${error ? 'has-error' : ''}`}
      role='radio'
      tabIndex={0}
      aria-checked={checked}
      onMouseDown={() => onMouseDown(id)}
      onMouseUp={() => onMouseUp(id)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') { onMouseDown(id); }
      }}
      onKeyUp={(e) => {
        if (e.key === 'Enter') { onMouseUp(id); }
      }}
    >
      <label
        className='control'
        htmlFor={`radio-item-${id}`}
      >
        <input
          type='radio'
          id={id}
          name={`radio-item-${id}`}
          value={id}
          checked={checked}
        />
        <Text paragraph align='center' className='label-text'>{label}</Text>
        {!isHorizontal && <div className='radio-target' />}
      </label>
    </div>
);

export default Radio;



// WEBPACK FOOTER //
// ./src/components/shared/Radio.js